import { render, staticRenderFns } from "./addAttributes.vue?vue&type=template&id=38bc7c98&scoped=true"
import script from "./addAttributes.vue?vue&type=script&lang=js"
export * from "./addAttributes.vue?vue&type=script&lang=js"
import style0 from "./addAttributes.vue?vue&type=style&index=0&id=38bc7c98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc7c98",
  null
  
)

export default component.exports